var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.549,
    height: 6.549,
    viewBox: "0 0 6.549 6.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: "0.5px",
    d: "M2.435,2.193l1.6-1.6A.267.267,0,0,0,3.66.214l-1.6,1.6L.455.214A.267.267,0,0,0,.078.591l1.6,1.6L.078,3.8a.267.267,0,1,0,.377.377l1.6-1.6,1.6,1.6A.267.267,0,0,0,4.037,3.8Zm0,0",
    transform: "translate(3.359 0.28) rotate(45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.50cdefba.svg";
export { ForwardRef as ReactComponent };